<div class="content-wrapper container-xxl p-0" xmlns="http://www.w3.org/1999/html">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="search()" />
            </div>
            <div class="col-xl-3 col-12" *ngIf="!_authenticationService.roleIs('Commerciale')">
              <ng-select [(ngModel)]="filterCommercial" (clear)="filterCommercial = {hash: null, complete_name: null}; search()"
                         [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="!!filterCommercial.hash" (ngModelChange)="search()">
                <ng-template ng-label-tmp let-item="item">{{ "CUSTOMER_COMMERCIAL" | translate }}: {{ item.complete_name || ('ALL' | translate) }}</ng-template>
                <ng-option [value]="{hash: null, complete_name: null}">{{ "ALL" | translate }}</ng-option>
                <ng-option *ngFor="let comm of commercialList" [value]="comm">{{ comm.complete_name }}</ng-option>
              </ng-select>
            </div>
            <div class="col-xl-3 col-12" *ngIf="!_authenticationService.roleIs('Recruiting')">
              <ng-select [(ngModel)]="filterRecruiter" (ngModelChange)="search()" (clear)="filterRecruiter = {hash: null, complete_name: null}; search()"
                         [closeOnSelect]="true" [searchable]="false" [openOnEnter]="true" [virtualScroll]="true" [clearable]="!!filterRecruiter.hash">
                <ng-template ng-label-tmp let-item="item">{{ "RECRUITER" | translate }}: {{ item.complete_name || ('ALL' | translate) }}</ng-template>
                <ng-option [value]="{hash: null, complete_name: null}">{{ "ALL" | translate }}</ng-option>
                <ng-option *ngFor="let recruiter of recruiterList" [value]="recruiter">{{ recruiter.complete_name }}</ng-option>
              </ng-select>
            </div>
            <div class="col-xl-2 text-right" [ngClass]="{
            'offset-xl-4': _authenticationService.roleIs('Recruiting') || _authenticationService.roleIs('Commerciale'),
            'offset-xl-1': !_authenticationService.roleIs('Recruiting') && !_authenticationService.roleIs('Commerciale')
            }" *ngIf="_utilService.isDesktop">
              <div class="d-inline-block ml-2">
                <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-2 mt-075 pt-1">
              <ng-select [(ngModel)]="filterFigure" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="!!filterFigure.id" (ngModelChange)="search()" (clear)="filterFigure = {id: null, name: null, users: null}; search()">
                <ng-template ng-label-tmp let-item="item">{{ "FIGURE" | translate }}: {{ item.name || ('ALL_FEMALE_PLURAL' | translate) }}</ng-template>
                <ng-option [value]="{id: null, name: null, users: null}">{{ "ALL_FEMALE_PLURAL" | translate }}</ng-option>
                <ng-option *ngFor="let figure of figureList" [value]="figure">{{ figure.name }}</ng-option>
              </ng-select>
            </div>

            <div class="col-xl-2 mt-075 pt-1">
              <ng-select [(ngModel)]="filterYear" [searchable]="false" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="loadHiredCandidates()">
                <ng-template ng-label-tmp let-item="item">{{ "YEAR" | translate | titlecase }}: {{ item }}</ng-template>
                <ng-option *ngFor="let year of yearList" [value]="year">{{ year }}</ng-option>
              </ng-select>
            </div>

            <div class="col-xl-2" [ngClass]="{'mt-05': filterFromDate.length, 'mt-075 pt-1': !filterFromDate.length}">
              <div class="d-flex justify-content-between font-small-3 font-weight-normal align-items-center">
                <label for="filterFromDate" class="mb-0" *ngIf="filterFromDate.length">{{ "FROM_START_DATE" | translate }}</label>
                <div class="text-primary cursor-pointer" *ngIf="filterFromDate.length" (click)="clearFilterDate('filterFromDate')">{{ 'REMOVE' | translate }}</div>
              </div>
              <app-datepickr id="filterFromDate" [placeholder]="'FROM_START_DATE' | translate" [defaultDate]="filterFromDate" (onSelect)="filterFromDate = $event; search()" [displayMonths]="1"></app-datepickr>
            </div>

            <div class="col-xl-2" [ngClass]="{'mt-05': filterToDate.length, 'mt-075 pt-1': !filterToDate.length}">
              <div class="d-flex justify-content-between font-small-3 font-weight-normal align-items-center">
                <label for="filterFromDate" class="mb-0" *ngIf="filterToDate.length">{{ 'TO_START_DATE' | translate }}</label>
                <div class="text-primary cursor-pointer" *ngIf="filterToDate.length" (click)="clearFilterDate('filterToDate')">{{ 'REMOVE' | translate }}</div>
              </div>
              <app-datepickr id="filterToDate" [placeholder]="'TO_START_DATE' | translate" [defaultDate]="filterToDate" (onSelect)="filterToDate = $event; search()" [displayMonths]="1"></app-datepickr>
            </div>

            <div class="col-xl-2" [ngClass]="{'mt-05': filterFromBargainingDate.length, 'mt-075 pt-1': !filterFromBargainingDate.length}">
              <div class="d-flex justify-content-between font-small-3 font-weight-normal align-items-center">
                <label for="filterFromDate" class="mb-0" *ngIf="filterFromBargainingDate.length">{{ 'FROM_BARGAINING_DATE' | translate }}</label>
                <div class="text-primary cursor-pointer" *ngIf="filterFromBargainingDate.length" (click)="clearFilterDate('filterFromBargainingDate')">{{ 'REMOVE' | translate }}</div>
              </div>
              <app-datepickr id="filterFromBargainingDate" [placeholder]="'FROM_BARGAINING_DATE' | translate" [defaultDate]="filterFromBargainingDate" (onSelect)="filterFromBargainingDate = $event; search()" [displayMonths]="1"></app-datepickr>
            </div>

            <div class="col-xl-2" [ngClass]="{'mt-05': filterToBargainingDate.length, 'mt-075 pt-1': !filterToBargainingDate.length}">
              <div class="d-flex justify-content-between font-small-3 font-weight-normal align-items-center">
                <label for="filterFromDate" class="mb-0" *ngIf="filterToBargainingDate.length">{{ 'TO_BARGAINING_DATE' | translate }}</label>
                <div class="text-primary cursor-pointer" *ngIf="filterToBargainingDate.length" (click)="clearFilterDate('filterToBargainingDate')">{{ 'REMOVE' | translate }}</div>
              </div>
              <app-datepickr id="filterToBargainingDate" [placeholder]="'TO_BARGAINING_DATE' | translate" [defaultDate]="filterToBargainingDate" (onSelect)="filterToBargainingDate = $event; search()" [displayMonths]="1"></app-datepickr>
            </div>

          </div>
        </div>

        <!--desktop-->
        <div class="card-body p-0">
          <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [rowHeight]="_utilService.isDesktop ? 50 : 200"
                         [limit]="tableLimit" [footerHeight]="50" [rows]="filterList" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }">
            <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" width="90" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a target="_blank" routerLink="/dashboard/user/profile/{{ row.hash }}">{{ row.complete_name }}</a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'FIGURE' | translate" prop="figure_name" width="100" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.figure_name }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CITY' | translate" prop="working_city_name" width="70" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.working_city_name || "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CUSTOMER_COMMERCIAL' | translate" prop="commercial.complete_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a *ngIf="row.commercial" [routerLink]="'/dashboard/user/profile/' + row.commercial?.hash" target="_blank">{{ row.commercial?.complete_name }}</a>
                <span *ngIf="!row.commercial">-</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'RECRUITER' | translate" prop="recruiter.complete_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a *ngIf="row.recruiter" [routerLink]="'/dashboard/user/profile/' + row.recruiter?.hash" target="_blank">{{ row.recruiter?.complete_name }}</a>
                <span *ngIf="!row.recruiter">-</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'START_DATE' | translate" prop="start_date" width="90" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.start_date ? (row.start_date | date: 'dd/MM/yyyy') : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'BARGAINING_INSERT_DATE' | translate" prop="bargaining_insert_date" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.bargaining_insert_date ? (row.bargaining_insert_date | date: 'dd/MM/yyyy') : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "NAME" | translate }}: </span>
                    <a target="_blank" routerLink="/dashboard/user/profile/{{ row.hash }}">{{ row.complete_name }}</a>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "FIGURE" | translate }}: </span>
                    <span>{{ row.figure }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "RECRUITER" | translate }}: </span>
                    <a *ngIf="row.recruiter" [routerLink]="'/dashboard/user/profile/' + row.recruiter?.hash" target="_blank">{{ row.recruiter?.complete_name }}</a>
                    <span *ngIf="!row.recruiter">-</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "CITY" | translate }}: </span>
                    <span>{{ row.working_city_name ? row.working_city_name : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "ASSUMPTION_DATE" | translate }}: </span>
                    <span>{{ row.start_date ? (row.start_date | date: 'dd/MM/yyyy') : "-" }}</span>
                  </div>
                  <div class="col-12 d-flex justify-content-end">
                    <!--Actions-->
                    <button type="button" class="bg-transparent border-0" [ngbTooltip]="'VIEW' | translate">
                      <a routerLink="/dashboard/user/profile/{{ row.hash }}"><i data-feather="eye" size="19"></i></a>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
